<template>
  <Modal title="添加监课记录" v-model="visible">
    <Form ref="recordForm" class="form" 
      :model="recordParam" :rules="recordRule"
      :label-width="80">
      <Row>
        <Col :span="22">
          <Form-item label="监课情况" prop="recordingContent">
            <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
              placeholder="长度不要超过100个字符"
              v-model="recordParam.recordingContent" ></Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingAdd" @click="add">确定</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'AddMonitorLessonRecordModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      openedId: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        recordParam: {
          recordingContent: '',
        },
        loadingAdd: false,
        recordRule: {
          recordingContent: [
            { type: 'string', required: true, message: '请填写监课情况', trigger: 'blur' },
            { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      add () {
        let self = this
        self.loadingAdd = true
        self.$refs.recordForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingAdd = false
            return
          }
          self.recordParam.opendId = self.openedId
          self.$http.post('/monitorLessonRecord/add', self.recordParam).then(function (res) {
            self.loadingAdd = false
            if (res) {
              self.$Message.success('添加成功!')
              self.visible = false
              return
            }
          })
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === true) {
          this.recordParam.recordingContent = ''
        }
        this.$emit('input', val)
      }
    }
  }  
</script>



// WEBPACK FOOTER //
// AddMonitorLessonRecordModal.vue?f37c04b2